import React from "react";
import {
  SidebarWrapper,
  SidebarNav,
  SideItem,
  SidebarButton,
  CloseButton,
} from "./style";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export const headerTab = [
  {
    title: "Home",
    direct: "/",
  },
  {
    title: "Galleries",
    direct: "/galleries",
  },
  {
    title: "Roadmap",
    direct: "/roadmap",
  },
];

type SidebarProps = {
  isshow: boolean;
  onClose: () => void;
};

const Sidebar = ({ isshow, onClose }: SidebarProps) => {
  const location = useLocation();
  return (
    <SidebarWrapper isshow={isshow}>
      <CloseButton>
        <span onClick={() => onClose()}>&times;</span>
      </CloseButton>
      <SidebarNav>
        {headerTab.length > 0
          ? headerTab.map((item, key) => (
              <SideItem key={key}>
                <Link
                  to={item.direct}
                  className={location.pathname === item.direct ? "active" : ""}
                >
                  {item.title}
                </Link>
              </SideItem>
            ))
          : ""}
      </SidebarNav>
      <SidebarButton>
        <a
          href="https://app.stellartai.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          Enter dAPP
        </a>
      </SidebarButton>
    </SidebarWrapper>
  );
};

export default Sidebar;
